<template>
  <div class="mv-progress-bar">
    <div class="current-pointer" :style="`width: ${rate}%`">{{ data.current }}</div>
    <div class="bar-area">
      <div class="upper-bar" :style="`width: ${rate}%`" />
      <div class="back-bar" />
    </div>
    <div class="pointer-row">
      <div class="limit-row">
        <div class="bar-pointer">{{ data.start }}</div>
        <div class="bar-pointer">{{ data.end }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent} from "vue";

export default defineComponent({
  name: "MvProgressBar",
  props: {
    data: {
      default: {
        start: 0,
        end: 10,
        current: 4,
      }
    }
  },
  setup(props) {
    const rate = computed(() => {
      const data = props.data
      return (data.current - data.start) * 100 / (data.end - data.start)
    })

    return {
      rate,
    }
  }
})
</script>
